import { types, actions } from './requests'
export const CREATETURN_TYPES = {
    ...types('CREATETURN'),
}
export const CREATETURN_ACTIONS = {
    ...actions('CREATETURN'),
}
